import { Broadcast } from '../types/broadcast';
import axios from 'axios';

const API_URL = 'https://api-coffee.8am.vn/api'; // Update this with your actual API URL

export const broadcastService = {
  async addBroadcast(broadcast: Broadcast) {
    try {
      const response = await axios.post(`${API_URL}/broadcasts`, broadcast);
      return response.data;
    } catch (error) {
      throw new Error('Could not add broadcast: ' + error);
    }
  },

  async updateBroadcast(id: string, broadcast: Partial<Broadcast>) {
    try {
      const response = await axios.put(`${API_URL}/broadcasts/${id}`, broadcast);
      return response.data;
    } catch (error) {
      throw new Error('Could not update broadcast: ' + error);
    }
  },

  async deleteBroadcast(id: string) {
    try {
      await axios.delete(`${API_URL}/broadcasts/${id}`);
    } catch (error) {
      throw new Error('Could not delete broadcast: ' + error);
    }
  },

  async getAllBroadcasts() {
    try {
      const response = await axios.get(`${API_URL}/broadcasts`);
      return response.data as Broadcast[];
    } catch (error) {
      throw new Error('Could not fetch broadcasts: ' + error);
    }
  },

  async sendBroadcast(id: string) {
    try {
      const response = await axios.post(`${API_URL}/broadcasts/${id}/send`);
      return response.data;
    } catch (error) {
      throw new Error('Could not send broadcast: ' + error);
    }
  },

  async getBroadcastById(id: string) {
    try {
      const response = await axios.get(`${API_URL}/broadcasts/${id}`);
      return response.data as Broadcast;
    } catch (error) {
      throw new Error('Could not fetch broadcast: ' + error);
    }
  },

  async scheduleBroadcast(id: string, scheduledTime: Date) {
    try {
      const response = await axios.post(`${API_URL}/broadcasts/${id}/schedule`, { scheduledTime });
      return response.data;
    } catch (error) {
      throw new Error('Could not schedule broadcast: ' + error);
    }
  },

  async cancelScheduledBroadcast(id: string) {
    try {
      const response = await axios.post(`${API_URL}/broadcasts/${id}/cancel`);
      return response.data;
    } catch (error) {
      throw new Error('Could not cancel scheduled broadcast: ' + error);
    }
  }
}; 